import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

export const CoverContainer = styled.div`
  width: 210mm;
  max-width: 210mm;
  height: 297mm;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
  font-family: ${vimovaTheme.fonts.body};
  box-sizing: border-box;
  background-color: ${vimovaTheme.colors.white};
  display: flex;
  flex-direction: column;

  @media print {
    width: 100% !important;
    max-width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    position: relative !important;
    height: 297mm !important;
    min-height: 297mm !important;
    max-height: 297mm !important;
    overflow: hidden !important;
    page-break-after: always !important;
    page-break-inside: avoid !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    background-color: ${vimovaTheme.colors.white} !important;
  }
`

export const HeroArea = styled.div`
  position: relative;
  width: 100%;
  height: 75%;
  border-radius: ${vimovaTheme.borderRadius.signatureLarge};
  overflow: hidden;

  @media print {
    height: 75% !important;
    border-radius: ${vimovaTheme.borderRadius.signatureLarge} !important;
    overflow: hidden !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HeroImage = styled.div<{ $imageUrl?: string }>`
  width: 100%;
  height: 100%;
  background: ${({ $imageUrl }) =>
    $imageUrl
      ? `url(${$imageUrl}) center/cover no-repeat`
      : vimovaTheme.colors.backgroundMuted};

  @media print {
    width: 100% !important;
    height: 100% !important;
    background: ${({ $imageUrl }) =>
      $imageUrl
        ? `url(${$imageUrl}) center/cover no-repeat`
        : `${vimovaTheme.colors.backgroundMuted}`} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HeroGradient = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, transparent 100%);
  pointer-events: none;

  @media print {
    position: absolute !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    height: 60% !important;
    background: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.7) 0%,
      transparent 100%
    ) !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const OrangeBracketDecoration = styled.div`
  position: absolute;
  top: 48px;
  left: 48px;
  z-index: 2;

  @media print {
    position: absolute !important;
    top: 48px !important;
    left: 48px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HeroLogoWrapper = styled.div`
  position: absolute;
  top: 48px;
  right: 48px;
  z-index: 2;

  @media print {
    position: absolute !important;
    top: 48px !important;
    right: 48px !important;
  }
`

export const DateBadgeBottom = styled.div`
  display: inline-block;
  background: ${vimovaTheme.colors.white};
  border-radius: 24px;
  padding: 8px 20px;
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.body};
  font-weight: ${vimovaTheme.fontWeights.normal};
  color: ${vimovaTheme.colors.textDark};

  @media print {
    display: inline-block !important;
    background: ${vimovaTheme.colors.white} !important;
    border-radius: 24px !important;
    padding: 8px 20px !important;
    font-size: ${vimovaTheme.fontSizes.body} !important;
    color: ${vimovaTheme.colors.textDark} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const EstimationBadge = styled.div`
  display: inline-block;
  background: ${vimovaTheme.colors.orange};
  border-radius: 24px;
  padding: 10px 28px;
  color: ${vimovaTheme.colors.white};
  font-family: ${vimovaTheme.fonts.heading};
  font-size: ${vimovaTheme.fontSizes.medium};
  font-weight: ${vimovaTheme.fontWeights.bold};
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 16px;

  @media print {
    display: inline-block !important;
    background: ${vimovaTheme.colors.orange} !important;
    border-radius: 24px !important;
    padding: 10px 28px !important;
    color: ${vimovaTheme.colors.white} !important;
    font-size: ${vimovaTheme.fontSizes.medium} !important;
    letter-spacing: 2px !important;
    margin-bottom: 16px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HeroContent = styled.div`
  position: absolute;
  bottom: 48px;
  left: 48px;
  right: 48px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media print {
    position: absolute !important;
    bottom: 48px !important;
    left: 48px !important;
    right: 48px !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
  }
`

export const PropertyInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: 4px !important;
  }
`

export const PropertyTitle = styled.h1`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: 28px;
  color: ${vimovaTheme.colors.white};
  margin: 0;
  line-height: 1.1;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: 28px !important;
    color: ${vimovaTheme.colors.white} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PropertyAddress = styled.p`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.xlarge};
  font-weight: ${vimovaTheme.fontWeights.bold};
  color: ${vimovaTheme.colors.white};
  margin: 8px 0 0 0;

  @media print {
    font-size: ${vimovaTheme.fontSizes.xlarge} !important;
    color: ${vimovaTheme.colors.white} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PriceTag = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.title};
  color: ${vimovaTheme.colors.green};
  text-align: right;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.title} !important;
    color: ${vimovaTheme.colors.green} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const GreenBracketDecoration = styled.div`
  position: absolute;
  bottom: 30px;
  right: 30px;
  z-index: 2;

  @media print {
    position: absolute !important;
    bottom: 30px !important;
    right: 30px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BottomSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 32px 24px 32px;

  @media print {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    padding: 24px 32px 24px 32px !important;
  }
`

export const ClientSection = styled.div`
  margin-bottom: 16px;

  @media print {
    margin-bottom: 16px !important;
  }
`

export const ClientLabel = styled.p`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.body};
  font-style: italic;
  color: ${vimovaTheme.colors.textMuted};
  margin: 0 0 4px 0;

  @media print {
    font-size: ${vimovaTheme.fontSizes.body} !important;
    font-style: italic !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ClientName = styled.p`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.large};
  color: ${vimovaTheme.colors.textDark};
  margin: 0;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.large} !important;
    color: ${vimovaTheme.colors.textDark} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const OwnerName = styled.p`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.body};
  color: ${vimovaTheme.colors.textLight};
  margin: 4px 0 0 0;

  @media print {
    font-size: ${vimovaTheme.fontSizes.body} !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BottomRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: auto;

  @media print {
    display: flex !important;
    justify-content: space-between !important;
    align-items: flex-end !important;
    margin-top: auto !important;
  }
`

export const BrokerCard = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  border: 1px solid ${vimovaTheme.colors.border};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 16px 24px;
  min-width: 320px;

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: 16px !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 16px 24px !important;
  }
`

export const BrokerPhoto = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;

  @media print {
    width: 52px !important;
    height: 52px !important;
    border-radius: 50% !important;
    object-fit: cover !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BrokerPhotoFallback = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: ${vimovaTheme.colors.primary};
  color: ${vimovaTheme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.large};
  flex-shrink: 0;

  @media print {
    width: 52px !important;
    height: 52px !important;
    border-radius: 50% !important;
    background: ${vimovaTheme.colors.primary} !important;
    color: ${vimovaTheme.colors.white} !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BrokerInfo = styled.div`
  display: flex;
  flex-direction: column;

  @media print {
    display: flex !important;
    flex-direction: column !important;
  }
`

export const BrokerName = styled.span`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.body};
  color: ${vimovaTheme.colors.textDark};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.body} !important;
    color: ${vimovaTheme.colors.textDark} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BrokerTitle = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.small};
  color: ${vimovaTheme.colors.textMuted};

  @media print {
    font-size: ${vimovaTheme.fontSizes.small} !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BrokerContact = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.small};
  color: ${vimovaTheme.colors.textMuted};
  margin-top: 4px;

  @media print {
    font-size: ${vimovaTheme.fontSizes.small} !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HeroEditOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.5);
  color: ${vimovaTheme.colors.white};
  font-family: ${vimovaTheme.fonts.heading};
  font-size: ${vimovaTheme.fontSizes.medium};
  font-weight: ${vimovaTheme.fontWeights.bold};
  padding: 12px 28px;
  border-radius: 24px;
  opacity: 0;
  transition: opacity 0.2s;
  z-index: 5;
  pointer-events: none;

  *:hover > & {
    opacity: 1;
  }

  @media print {
    display: none !important;
  }
`
